module.exports = __webpack_public_path__ + "static/fonts/KPMG-Bold 151012.400ce7b3.otf";